


























































































import Vue from 'vue'
import AppDialogConfirm from '@morpheus/utils/admin-vue/components/AppDialogConfirm.vue'
import { VersionShowData } from '../types'

export default Vue.extend({
  name: 'VersionsList',
  components: {
    AppDialogConfirm
  },
  props: {
    headers: {
      required: true,
      type: Array as () => Array<any>
    },
    items: {
      required: true,
      type: Array as () => Array<VersionShowData>
    },
    totalItems: {
      required: true,
      type: Number
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showDialog: false,
      dialogMessage: '',
      itemIdInAction: '',
      actionOnConfirm: '',
      versionStatus: false
    }
  },
  methods: {
    deleteVersion (event: any, id: string, itemName: string) {
      this.dialogMessage = `Are you sure you want to delete version ${itemName}?`
      this.showDialog = true
      this.itemIdInAction = id
      this.actionOnConfirm = 'delete'
    },
    cancelAction () {
      this.showDialog = false
    },
    confirmAction () {
      if (this.actionOnConfirm === 'delete') {
        this.confirmDeleteVersion()
      } else if (this.actionOnConfirm === 'enable') {
        this.confirmEnableVersion()
      }
    },
    confirmDeleteVersion () {
      this.showDialog = false
      this.$emit('onDeleteVersion', this.itemIdInAction)
    },
    enableVersion (event: any, id: string, status: boolean, itemName: string) {
      this.dialogMessage = `Are you sure you want to change status of the version ${itemName}?`
      this.showDialog = true
      this.versionStatus = status
      this.itemIdInAction = id
      this.actionOnConfirm = 'enable'
    },
    confirmEnableVersion () {
      this.showDialog = false
      this.$emit('onEnableVersion', this.itemIdInAction, this.versionStatus)
    }
  }
})
